"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _utils = require("@ori-ui/mui-bundle/material/utils");
var _jsxRuntime = require("react/jsx-runtime");
var _default = exports.default = (0, _utils.createSvgIcon)(/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M12.488 5.892a.5.5 0 0 0-.976 0c-.158.711-.516 1.78-1.061 2.656C9.89 9.448 9.229 10 8.5 10c-.829 0-1.589-.415-2.226-.995a6.3 6.3 0 0 1-1.327-1.729.5.5 0 0 0-.938.316l1.347 7.184A1.5 1.5 0 0 0 6.83 16h10.34a1.5 1.5 0 0 0 1.474-1.224l1.347-7.184a.5.5 0 0 0-.938-.316 6.3 6.3 0 0 1-1.327 1.729c-.637.58-1.397.995-2.226.995-.73 0-1.39-.552-1.95-1.452-.546-.877-.904-1.945-1.062-2.656M8.5 11c1.27 0 2.193-.948 2.8-1.923A9 9 0 0 0 12 7.67c.188.471.421.958.7 1.407.607.975 1.53 1.923 2.8 1.923 1.171 0 2.161-.585 2.899-1.255q.106-.098.209-.198l-.946 5.045a.5.5 0 0 1-.492.408H6.83a.5.5 0 0 1-.492-.408l-.946-5.045q.102.1.21.198C6.338 10.415 7.328 11 8.5 11m-2 7a.5.5 0 0 0 0 1h11a.5.5 0 1 0 0-1z"
}), 'Crown');
